import { createSelector } from '@reduxjs/toolkit'

export const selectLocale = createSelector(
  (state) => state.locale,
  (locale) => {
    return locale.strings
  }
)

export const selectTenantIntegration = createSelector(
  (state) => state.login.userData.hasIntegration,
  (integration) => {
    return integration
  }
)
